import { useEffect } from 'react';

import { CuredApiPaths } from 'models/enums';
import Card from 'pages/InsightsPage/dashboards/Card';
import { FiltersForApiState } from 'pages/InsightsPage/dashboards/filtering/types';
import useFilteredData from 'pages/InsightsPage/dashboards/filtering/useFilteredData';
import BarGraph from 'pages/InsightsPage/visualizations/BarGraph';

type Props = {
    filtersForApi: FiltersForApiState;
};

const CallDurationDensityOverTimeCard = ({ filtersForApi }: Props) => {
    const { getData, isError, isLoading, data } = useFilteredData({
        key: 'voice-dashboard/call-duration-density-over-time',
        path: CuredApiPaths.REPORT_VOICE_CALL_DURATION_DENSITY_OVER_TIME,
    });

    useEffect(() => {
        getData(filtersForApi);
    }, [filtersForApi, getData]);

    return (
        <Card isError={isError} isLoading={isLoading} label="Call Duration Density">
            <BarGraph bottomLegendLabel="time" data={data} leftLegendLabel="number of calls" />
        </Card>
    );
};

export default CallDurationDensityOverTimeCard;
